import React from 'react'
import AgreementRow from './agreement-row/agreement-row'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

interface IAgreementTableProps {
  showPreviousYear: boolean
  setShowPreviousYear: (showPreviousYear: boolean) => void
  reportedYears?: Array<number>
  selectedYear?: number
  setSelectedYear: (selectedYear: number) => void
  tableHeads: Array<{ label: string }>
  filteredData: any
  collectiveAgreements: { [key: string]: string }
}

const AgreementTable: React.FC = ({
  showPreviousYear,
  setShowPreviousYear,
  reportedYears,
  selectedYear,
  setSelectedYear,
  tableHeads,
  filteredData,
  collectiveAgreements,
}: IAgreementTableProps) => {
  return (
    <div>
      <button
        className="text-darkBlue font-semibold text-md mt-2 flex flex-row gap-2 items-center"
        onClick={() => setShowPreviousYear(!showPreviousYear)}
      >
        Tidigare år
        {showPreviousYear ? (
          <FontAwesomeIcon icon={faChevronUp} />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} />
        )}
      </button>
      {showPreviousYear && (
        <div>
          <div className="mt-4">
            {reportedYears
              ? reportedYears.map((year, index) => {
                  if (year) {
                    return (
                      <button
                        className={`p-2 rounded text-md text-darkBlue ${
                          year === selectedYear ? 'font-bold underline' : 'font-normal'
                        }`}
                        key={index}
                        onClick={() => setSelectedYear(year)}
                      >
                        {year}
                      </button>
                    )
                  }
                  return null
                })
              : null}
          </div>

          <div className="overflow-auto flex flex-col gap-4">
            <table className="table">
              <thead className="thead">
                <tr className="tr">
                  {tableHeads.map((head, index) => {
                    return (
                      <th key={index} className="th font-bold w-1/2">
                        {head.label}
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody className="tbody">
                {filteredData && collectiveAgreements
                  ? Object.keys(collectiveAgreements).map((collectiveAgreementKey, index) => {
                      if (collectiveAgreementKey !== '') {
                        let prevNumEmployees = 0
                        if (filteredData.previous && filteredData.previous.data) {
                          const tempPrevNumEmployees = filteredData.previous.data.find(
                            (element) => element.collectiveAgreement === collectiveAgreementKey,
                          )
                          prevNumEmployees =
                            tempPrevNumEmployees && tempPrevNumEmployees.numEmployees !== null
                              ? tempPrevNumEmployees.numEmployees
                              : 0
                        }
                        let numEmployees = 0
                        if (filteredData.current && filteredData.current.data) {
                          const tempCurrent = filteredData.current.data.find(
                            (element) => element.collectiveAgreement === collectiveAgreementKey,
                          )
                          numEmployees =
                            tempCurrent && tempCurrent.numEmployees !== null
                              ? tempCurrent.numEmployees
                              : 0
                        }
                        const data = {
                          collectiveAgreementLabel: collectiveAgreements[collectiveAgreementKey],
                          collectiveAgreement: collectiveAgreementKey,
                          numEmployees,
                          prevNumEmployees,
                        }
                        return <AgreementRow key={index} data={data} />
                      }
                      return null
                    })
                  : null}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}

export default AgreementTable
